"use strict";

exports.__esModule = true;
exports.DeviceValueColorSource = DeviceValueColorSource;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Translator = require("../../../Core/Translator");
var _ColorPicker = require("../../../Form/ColorPicker");
var _DeviceColorSource = require("../DeviceColorSource");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ValueSetColorSelectorWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DeviceValueColorSource__ValueSetColorSelectorWrapper",
  componentId: "sc-q7qf9e-0"
})(["display:flex;flex-direction:column;"]);
var AddValueSetButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DeviceValueColorSource__AddValueSetButtonWrapper",
  componentId: "sc-q7qf9e-1"
})(["margin:5px 0;"]);
var BackgroundColorValueWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DeviceValueColorSource__BackgroundColorValueWrapper",
  componentId: "sc-q7qf9e-2"
})(["display:grid;grid-template-areas:\"eqType input colorPicker close\";"]);
var getInitialValueColorTuple = function getInitialValueColorTuple() {
  var id = Date.now();
  return {
    id: id,
    value: "",
    color: "#fb9e00"
  };
};
function DeviceValueColorSource(props) {
  var values = props.value,
    onChange = props.onChange;
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var setValues = function setValues(newVals) {
    onChange(newVals);
  };
  return /*#__PURE__*/_react["default"].createElement(ValueSetColorSelectorWrapper, null, /*#__PURE__*/_react["default"].createElement(AddValueSetButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    text: translate("AdvancedTimelineValue.fields.addValueSetBackgroundColor", "Add Color"),
    "data-testid": "ColorValueSourceAddButton",
    onClick: function onClick() {
      setValues(values.concat(getInitialValueColorTuple()));
    },
    icon: _icons.IconNames.ADD
  })), values.map(function (_ref, idx) {
    var id = _ref.id,
      value = _ref.value,
      color = _ref.color,
      eqType = _ref.eqType;
    return /*#__PURE__*/_react["default"].createElement(BackgroundColorValueWrapper, {
      "data-testid": "ColorValueWrapper",
      key: id
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.HTML_SELECT,
      style: {
        gridArea: "eqType"
      }
    }, /*#__PURE__*/_react["default"].createElement("select", {
      value: eqType || _DeviceColorSource.RAW_VALUE_EQUALS,
      onChange: function onChange(selectedEqType) {
        var updated = values.slice();
        updated[idx] = Object.assign({}, updated[idx], {
          eqType: selectedEqType.target.value || _DeviceColorSource.RAW_VALUE_EQUALS
        });
        setValues(updated);
      }
    }, /*#__PURE__*/_react["default"].createElement("option", {
      value: _DeviceColorSource.RAW_VALUE_GREATER_THAN
    }, ">"), /*#__PURE__*/_react["default"].createElement("option", {
      value: _DeviceColorSource.RAW_VALUE_LOWER_THAN
    }, "<"), /*#__PURE__*/_react["default"].createElement("option", {
      value: _DeviceColorSource.RAW_VALUE_EQUALS
    }, "="), /*#__PURE__*/_react["default"].createElement("option", {
      value: _DeviceColorSource.RAW_VALUE_CONTAINS
    }, "Contains"))), /*#__PURE__*/_react["default"].createElement(_core.InputGroup, {
      "data-testid": "ColorValueSourceInput",
      style: {
        gridArea: "input"
      },
      type: "text",
      value: value,
      onChange: function onChange(event) {
        var updated = values.slice();
        updated[idx] = Object.assign({}, updated[idx], {
          value: event.target.value
        });
        setValues(updated);
      }
    }), /*#__PURE__*/_react["default"].createElement(_ColorPicker.ColorPicker, {
      "data-testid": "ColorPickerButton",
      style: {
        gridArea: "colorPicker"
      },
      value: color,
      onChange: function onChange(selectedColor) {
        var updated = values.slice();
        updated[idx] = Object.assign({}, updated[idx], {
          color: selectedColor || ""
        });
        setValues(updated);
      }
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "ColorValueSourceRemoveButton",
      style: {
        gridArea: "close"
      },
      icon: _icons.IconNames.CROSS,
      onClick: function onClick() {
        var updated = values.filter(function (_, index) {
          return index !== idx;
        });
        setValues(updated);
      }
    }));
  }));
}